import {getDefaultCheck, getTagWithStatus} from '@/assets/js/api';

/**
 * 案件办理模块
 * **/
export default {
  state: {
    // 标签
    tagWithStatus: {
      common: [],
      self: [
        {codeList: []}
      ]
    },
    // 选中的标签
    checkedTagList: new Set([])
  },
  mutations: {
    Set_Default_Check: (state, _data) => {
      if (_data.code === 200 && _data.data.tagIdList) {
        state.checkedTagList = new Set(_data.data.tagIdList);
      }
    },
    Set_Tag_With_Status: (state, _data) => {
      if (_data.code === 200) {
        state.tagWithStatus.common = _data.data.common;
        const self = _data.data.self[0];
        state.tagWithStatus.self[0].codeList = self ? self.codeList : [];
      }
    },
    Add_DIY_Tag: (state, _data) => {
      state.tagWithStatus.self[0].codeList.push(_data);
    },
    Del_DIY_Tag: (state, _data) => {
      const codeList = state.tagWithStatus.self[0].codeList;
      state.checkedTagList.delete(_data);
      for (let i = 0; i < codeList.length; i++) {
        if (codeList[i].code === _data) {
          codeList.splice(i, 1);
        }
      }
    },
    Checked_Tag: (state, _data) => {
      const code = _data.code;
      if (state.checkedTagList.has(code)) {
        state.checkedTagList.delete(code);
      } else {
        _data.codeList.map(item => {
          state.checkedTagList.delete(item.code);
        });
        state.checkedTagList.add(code);
      }
    },
  },
  actions: {
    // 查询用户默认筛选项
    async GetDefaultCheck({commit}, params) {
      await getDefaultCheck(params).then((res) => {
        commit('Set_Default_Check', res);
      });
    },
    // 根据案件状态获取标签
    async GetTagWithStatus({commit}, params) {
      await getTagWithStatus(params).then((res) => {
        commit('Set_Tag_With_Status', res);
      });
    },
    // 添加自定义标签
    addDIYTag({commit}, data) {
      commit('Add_DIY_Tag', data);
    },
    delDIYTag({commit}, data) {
      commit('Del_DIY_Tag', data);
    },
    // 选中标签
    checkedTag({commit}, data) {
      commit('Checked_Tag', data,);
    }
  }
};
